<template>
    <div class="participants">
        <van-list v-model="loading" :finished="finished" finished-text="已加载全部" @load="onLoad">
            <div v-for="(item, index) in pList" class="item flex" :key="index">
                <div class="img_name flex">
                    <img :src="item.customericonurl" :alt="item.customername">
                    <span class="name">{{item.customername}}</span>
                    <span class="item_count">× {{item.itemcount}}份</span>
                </div>
                <div class="time">{{item.datetime}}</div>
            </div>
        </van-list>
    </div>
</template>

<script>
import {getEventTicketUser} from 'api/activeTools.js'
import { mapActions} from 'vuex'

export default {
    name: 'Participants',
    data() {
        return {
            eventid: this.$route.query.eventid ? this.$route.query.eventid : '1000016',
            pList: [],
            loading: false,
            finished: false,
            pageIdx: 1
        }
    },
    mounted() {
        // this.getParticipantList()
        document.title = '报名人员'
    },
    methods: {
        onLoad() {
            this.getParticipantList()
        },

        getParticipantList() {
            let data = {
                eventid: this.eventid,
                page: this.pageIdx,
                pageSize: 20
            }
            getEventTicketUser({
                data: data,
                success: data => {
                    this.setLoading(false)
                    if (data.data) {
                        if (data.data.enrolllist) {
                            data.data.enrolllist.forEach(obj => {
                                this.pList.push(obj)
                            })
                        }
                        this.loading = false
                        if (data.data.pageinfo.rowCount === this.pList.length) {
                            this.finished = true
                        } else {
                            this.pageIdx ++
                        }
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },

        ...mapActions([
            'setLoading',
            'setIsInit'
        ])
    }
}
</script>

<style lang="scss">
.flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.participants {
    padding: 0 .3rem;
    background: #fff;
    .item {
        color: #333;
        border-bottom: .01rem solid #E5E5E5;
        padding: .24rem 0;
        .img_name {
            .name {
                font-size: .32rem;
                padding-right: .1rem;
            }
            .item_count {
                font-size: .24rem;
                color: #999;
            }
            img {
                display: inline-block;
                width: .72rem;
                height: .72rem;
                border-radius: 50%;
                margin-right: .3rem;
            }
        }
        .time {
            font-size: .28rem;
        }
    }
    .item:last-child {
        border: none;
    }
}
</style>


